<template>
  <div class="shop-form__block _form">
    <div class="text" v-if="loyalityShopData.receiver === 'other'">
      На кого оформить подарок
    </div>
    <div class="inputwrapper">
      <button class="errorblock close" v-if="invalidName"  @click="(event) => {nextElementFocus(event); invalidName = false; }">Укажите корректное имя</button>
      <input
        class="input"
        :class="{ error: invalidName }"
        type="text"
        v-model="clientData.name"
        ref="nameInput"
        :placeholder="'Имя фамилия'
        "
      />
    </div>
    <div
      class="inputwrapper"
      v-if="
        receiver === 'other' || (receiver === 'self' && !$store.getters.isAuth)
      "
    >
      <button v-if="invalidPhone" class="errorblock close" @click="(event) => {nextElementFocus(event); invalidPhone = false; }"
        >Укажите корректный телефон</button
      >
      <MaskInput
        v-model="clientData.phone"
        ref="phoneInput"
        class="input"
        :class="{ error: invalidPhone }"
        type="tel"
        :mask="'+7 ### ### ## ## ##'"
        placeholder="+ *** *** ** **"
      />
    </div>
    <div class="confirm" v-else>
      <span class="number">{{ store.state.authModule.authPhone }}</span>
      <span class="ready">Подтверждено</span>
    </div>

    <div class="inputwrapper" v-if="receiver === 'self'">
      <button class="errorblock close" v-if="invalidEmail"  @click="(event) => {nextElementFocus(event); invalidEmail = false; }"
        >Укажите корректный Email</button
      >
      <input
        class="input post _disabled-text-hide"
        type="text"
        placeholder="Почта"
        v-model="clientData.email"
        ref="emailInput"
        :class="{
          error: invalidEmail && loyalityShopData.emailRecipient === 'self',
        }"
        :disabled="loyalityShopData.emailRecipient !== 'self'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import nextElementFocus from '@/functions/nextElementFocus'
import { defineExpose } from "vue";
const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);

const receiver = computed<TypeReceiver>(
  () => store.state.loyalityShopData.receiver
);

const clientData = computed(() => loyalityShopData.value.clientData);
const buyerData = computed(() => loyalityShopData.value.buyerData);

const nameInput = ref<HTMLInputElement | null>(null);
const phoneInput = ref<any>(null);
const emailInput = ref<HTMLInputElement | null>(null);
const emailRecipientInput = ref<HTMLInputElement | null>(null);

let invalidName = ref<boolean>(false);
let invalidPhone = ref<boolean>(false);
let invalidEmail = ref<boolean>(false);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateClientData(): boolean {
  const clientName = loyalityShopData.value.clientData.name || null;
  const clientPhone = loyalityShopData.value.clientData.phone ? loyalityShopData.value.clientData.phone.replace("+", "").replace(/\s+/g, "") : null;
  const clientEmail = loyalityShopData.value.clientData.email || null;
  if (
    !clientName ||
    clientName.length < 2
  ) {
    invalidName.value = true;

    nameInput?.value?.focus();
    return false;
  } else {
    invalidName.value = false;
  }

  if (
    !clientPhone ||
    clientPhone.length < 11
  ) {
    invalidPhone.value = true;

    console.log(phoneInput);
    phoneInput?.value?.$el.focus();
    return false;
  } else {
    invalidPhone.value = false;
  }

  if (receiver.value === "self") {
    const validatorValue =
      !!clientEmail &&
      emailRegex.test(clientEmail);

    if (validatorValue === false) {
      invalidEmail.value = true;
      return false;
    } else {
      invalidEmail.value = false;
    }
  }

  return true;
}

// Экспортируем метод, чтобы он был доступен из родительского компонента
defineExpose({ validateClientData });
</script>

<style></style>
